<template>
  <j-modal 
    :title="title" 
    :width="width" 
    height="870px"
    :visible="visible" 
    :confirmLoading="confirmLoading" 
    :keyboard="false" 
    :forceRender="true" 
    switchFullscreen 
    @cancel="handleCancel" 
    >
    <template slot="footer">
      <a-button @click="handleCancel">取消</a-button>
      <!-- <a-button v-if="checkFlag && isCanCheck" :loading="confirmLoading" @click="handleOkAndCheck">保存并审核</a-button> -->
      <a-button type="primary" :loading="confirmLoading" @click="handleOk">保存</a-button>
      <!--发起多级审核-->
      <a-button v-if="!checkFlag" @click="handleWorkflow()" type="primary">提交流程</a-button>
    </template>
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-row class="form-row" :gutter="24">
          <a-col :lg="6" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="报告单号">
              <a-input placeholder="请输入报告单号" v-decorator.trim="[ 'code' ]"/>
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="检测日期">
              <j-date v-decorator="['date']" :show-time="true" />
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="受理人">
              <a-input placeholder="请输入受理人" v-decorator.trim="[ 'acceptedBy' ]"/>
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="运输工具">
              <a-input placeholder="请输入运输工具" v-decorator.trim="[ 'transportationTools' ]"/>
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="冷藏方式">
              <a-input placeholder="请输入冷藏方式" v-decorator.trim="[ 'refrigerationMethod' ]"/>
            </a-form-item>
          </a-col>
          <!-- <a-col :lg="6" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品编号">
              <a-input placeholder="请输入产品编号" v-decorator.trim="[ 'productNumber' ]"/>
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品名称">
              <a-input placeholder="请输入产品名称" v-decorator.trim="[ 'productName' ]"/>
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品规格">
              <a-input placeholder="请输入产品规格" v-decorator.trim="[ 'productModel' ]"/>
            </a-form-item>
          </a-col> -->
          <a-col :lg="6" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品注册证号">
              <a-input placeholder="请输入产品注册证号" v-decorator.trim="[ 'regCode' ]"/>
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="注册人/备案人">
              <a-input placeholder="请输入注册人/备案人" v-decorator.trim="[ 'regBy' ]"/>
            </a-form-item>
          </a-col>
          <!-- <a-col :lg="6" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="批号/序列号">
              <a-input placeholder="请输入批号/序列号" v-decorator.trim="[ 'serialNumber' ]"/>
            </a-form-item>
          </a-col> -->
          <!-- <a-col :lg="6" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="数量">
              <a-input placeholder="请输入数量" v-decorator.trim="[ 'number' ]"/>
            </a-form-item>
          </a-col> -->
          <a-col :lg="6" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="计量单位">
              <a-input placeholder="请输入计量单位" v-decorator.trim="[ 'unitMeasurement' ]"/>
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="起运日期">
              <j-date v-decorator="['startTime']" :show-time="true" />
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="起运冰排状态">
              <a-input placeholder="请输入起运冰排状态" v-decorator.trim="[ 'startIceState' ]"/>
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="起运储存温度℃">
              <a-input placeholder="请输入起运储存温度℃" v-decorator.trim="[ 'saveTemperature' ]"/>
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="起运环境温度℃">
              <a-input placeholder="请输入起运环境温度℃" v-decorator.trim="[ 'ambientTemperature' ]"/>
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="到达日期">
              <j-date v-decorator="['reachTime']" :show-time="true" />
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="到达存储温度℃">
              <a-input placeholder="请输入到达存储温度℃" v-decorator.trim="[ 'reachTemperature' ]"/>
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="到达环境温度℃">
              <a-input placeholder="请输入到达环境温度℃" v-decorator.trim="[ 'reachAmbientTemperature' ]"/>
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="到达冰排状态">
              <a-input placeholder="请输入到达冰排状态" v-decorator.trim="[ 'reachIceState' ]"/>
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="运输途中温度℃">
              <a-input placeholder="请输入运输途中温度℃" v-decorator.trim="[ 'inTransitTemperature' ]"/>
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="运货人">
              <a-input placeholder="请输入运货人" v-decorator.trim="[ 'freightCarrier' ]"/>
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="运货单位">
              <a-input placeholder="请输入运货单位" v-decorator.trim="[ 'freightComplaint' ]"/>
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="收货人">
              <a-input placeholder="请输入收货人" v-decorator.trim="[ 'consignee' ]"/>
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="收货单位">
              <a-input placeholder="请输入收货单位" v-decorator.trim="[ 'consigneeComplaint' ]"/>
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="12" :sm="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
              <a-textarea placeholder="请输入备注" v-decorator.trim="[ 'remark' ]" :autoSize="{ minRows: 3 }"></a-textarea>
            </a-form-model-item>
          </a-col>
        </a-row>
        <j-editable-table id="billModal" :ref="refKeys[0]" :loading="materialTable.loading" :columns="materialTable.columns" :dataSource="materialTable.dataSource" :minWidth="minWidth" :maxHeight="300" :rowNumber="false" :rowSelection="rowCanEdit" :actionButton="rowCanEdit" :dragSort="rowCanEdit" @valueChange="onValueChange" @added="onAdded" @deleted="onDeleted">
          <!-- <template #buttonAfter>
            <a-row v-if="rowCanEdit" :gutter="24" style="float:left;" data-step="4" data-title="扫码录入" data-intro="此功能支持扫码枪扫描商品条码进行录入">
              <a-col v-if="scanStatus" :md="8" :lg="6"  :sm="24">
                <a-button @click="scanEnter">扫码录入</a-button>
              </a-col>
              <a-col v-if="!scanStatus" :md="16" :sm="24" style="padding: 0 8px 0 12px">
                <a-input placeholder="请扫描商品条码并回车" v-model="scanBarCode" @pressEnter="scanPressEnter" ref="scanBarCode" />
              </a-col>
              <a-col v-if="!scanStatus" :md="8" :lg="6"  :sm="24" style="padding: 0px 12px 0 0">
                <a-button @click="stopScan">收起扫码</a-button>
              </a-col>
            </a-row>
            <a-row v-if="rowCanEdit" :gutter="24" style="float:left;padding-bottom: 5px;padding-left:20px;">
              <a-button icon="import" @click="onImport(prefixNo)">导入明细</a-button>
            </a-row>
          </template> -->
          <template #depotBatchSet>
            <a-icon type="down" @click="handleBatchSetDepot" />
          </template>
          <template #depotAdd>
            <a-divider v-if="isTenant" style="margin: 4px 0;" />
            <div v-if="isTenant || showAddDepot" style="padding: 4px 8px; cursor: pointer;" @click="addDepot"><a-icon type="plus" /> 新增仓库</div>
          </template>
        </j-editable-table>
        <a-row class="form-row" :gutter="24">
          <a-col :lg="24" :md="24" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="{xs: { span: 24 },sm: { span: 24 }}" label="">
              <a-textarea :rows="1" placeholder="请输入备注" v-decorator="[ 'remark' ]" style="margin-top:8px;" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row class="form-row" :gutter="24">
          <a-col :lg="6" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="附件">
              <j-upload v-model="fileList" bizPath="bill"></j-upload>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
    <vendor-modal ref="vendorModalForm" @ok="vendorModalFormOk"></vendor-modal>
    <depot-modal ref="depotModalForm" @ok="depotModalFormOk"></depot-modal>
    <batch-set-depot ref="batchSetDepotModalForm" @ok="batchSetDepotModalFormOk"></batch-set-depot>
    <import-item-modal ref="importItemModalForm" @ok="importItemModalFormOk"></import-item-modal>
    <wait-bill-list ref="waitBillList" @ok="waitBillListOk"></wait-bill-list>
    <workflow-iframe ref="modalWorkflow"></workflow-iframe>
  </j-modal>
</template>
<script>
import pick from 'lodash.pick'
import VendorModal from '../../system/modules/VendorModal'
import DepotModal from '../../system/modules/DepotModal'
import BatchSetDepot from '../dialog/BatchSetDepot'
import ImportItemModal from '../dialog/ImportItemModal'
import WorkflowIframe from '@/components/tools/WorkflowIframe'
import { FormTypes } from '@/utils/JEditableTableUtil'
import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'
import { BillModalMixin } from '../mixins/BillModalMixin'
import { getMpListShort } from '@/utils/util'
import JUpload from '@/components/jeecg/JUpload'
import JDate from '@/components/jeecg/JDate'
import Vue from 'vue'
import WaitBillList from '../dialog/WaitBillList'
export default {
  name: 'OtherInModal',
  mixins: [JEditableTableMixin, BillModalMixin],
  components: {
    VendorModal,
    DepotModal,
    BatchSetDepot,
    ImportItemModal,
    WaitBillList,
    WorkflowIframe,
    JUpload,
    JDate,
    VNodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes,
    },
  },
  data() {
    return {
      title: '操作',
      width: '1600px',
      moreStatus: false,
      // 新增时子表默认添加几行空数据
      addDefaultRowNum: 1,
      visible: false,
      operTimeStr: '',
      prefixNo: 'LLYS',
      fileList: [],
      rowCanEdit: true,
      //出入库管理开关，适合独立仓管场景
      inOutManageFlag: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      refKeys: ['materialDataTable'],
      activeKey: 'materialDataTable',
      materialTable: {
        loading: false,
        dataSource: [],
        columns: [
          {
            title: '仓库名称',
            key: 'depotId',
            width: '8%',
            type: FormTypes.select,
            placeholder: '请选择${title}',
            options: [],
            allowSearch: true,
            validateRules: [{ required: true, message: '${title}不能为空' }],
          },
          {
            title: '条码',
            key: 'barCode',
            width: '12%',
            type: FormTypes.popupJsh,
            kind: 'material',
            multi: true,
            validateRules: [{ required: true, message: '${title}不能为空' }],
          },
          { title: 'ID', key: 'materialId', width: '10%', type: FormTypes.normal },
          { title: '名称', key: 'name', width: '10%', type: FormTypes.normal },
          { title: '规格', key: 'standard', width: '9%', type: FormTypes.normal },
          { title: '型号', key: 'model', width: '9%', type: FormTypes.normal },
          { title: '颜色', key: 'color', width: '5%', type: FormTypes.normal },
          { title: '扩展信息', key: 'materialOther', width: '5%', type: FormTypes.normal },
          { title: '库存', key: 'stock', width: '5%', type: FormTypes.normal },
          { title: '单位', key: 'unit', width: '4%', type: FormTypes.normal },
          { title: '序列号', key: 'snList', width: '12%', type: FormTypes.popupJsh, kind: 'snAdd', multi: true },
          { title: '批号', key: 'batchNumber', width: '7%', type: FormTypes.input },
          { title: '有效期', key: 'expirationDate', width: '7%', type: FormTypes.date },
          { title: '多属性', key: 'sku', width: '9%', type: FormTypes.normal },
          { title: '原数量', key: 'preNumber', width: '4%', type: FormTypes.normal },
          { title: '已入库', key: 'finishNumber', width: '4%', type: FormTypes.normal },
          {
            title: '数量',
            key: 'operNumber',
            width: '5%',
            type: FormTypes.inputNumber,
            statistics: true,
            validateRules: [{ required: true, message: '${title}不能为空' }],
          },
          { title: '单价', key: 'unitPrice', width: '5%', type: FormTypes.inputNumber },
          { title: '金额', key: 'allPrice', width: '5%', type: FormTypes.inputNumber, statistics: true },
          { title: '备注', key: 'remark', width: '5%', type: FormTypes.input },
          { title: '关联id', key: 'linkId', width: '5%', type: FormTypes.hidden },
          { title: '关联id2', key: 'enableSerialNumber', width: '5%', type: FormTypes.hidden },
        ],
      },
      confirmLoading: false,
      validatorRules: {
        operTime: {
          rules: [{ required: true, message: '请输入单据日期!' }],
        },
        type: {
          rules: [{ required: true, message: '请选择类型!' }],
        },
      },
      url: {
        add: '/quality/transportMonitor/add',
        edit: '/quality/transportMonitor/edit',
        detailList: '/quality/inspectionAssociation/getDetailList',
      },
    }
  },
  created() {},
  methods: {
    // edit(record){
    //   this.visible = true
    //   console.log(record,'record=================')
    //   this.model = { ...this.model, ...record } 
    //   this.editAfter()
    // },
    //调用完edit()方法之后会自动调用此方法editAfter
    editAfter() {
      debugger
      this.billStatus = '0'
      this.currentSelectDepotId = ''
      this.rowCanEdit = true
      this.changeColumnHide()
      this.changeFormTypes(this.materialTable.columns, 'snList', 0)
      this.changeFormTypes(this.materialTable.columns, 'batchNumber', 0)
      this.changeFormTypes(this.materialTable.columns, 'expirationDate', 0)
      this.changeFormTypes(this.materialTable.columns, 'preNumber', 0)
      this.changeFormTypes(this.materialTable.columns, 'finishNumber', 0)
      if (this.action === 'add') {
        this.addInit(this.prefixNo)
        this.fileList = []
      } else {
        if (this.model.linkNumber) {
          this.rowCanEdit = false
          this.materialTable.columns[1].type = FormTypes.normal
        }
        this.model.operTime = this.model.operTimeStr
        this.fileList = this.model.fileName
        this.$nextTick(() => {
          this.form.setFieldsValue(
            pick(
              this.model,
              'code',
              'date',
              'acceptedBy',
              'transportationTools',
              'refrigerationMethod',
              'regCode',
              'regBy',
              'unitMeasurement',
              'startTime',
              'startIceState',
              'saveTemperature',
              'ambientTemperature',
              'reachTime',
              'reachTemperature',
              'reachAmbientTemperature',
              'reachIceState',
              'inTransitTemperature',
              'freightCarrier',
              'freightComplaint',
              'consignee',
              'consigneeComplaint',
              'remark'
            )
          )
        })
        // 加载子表数据
        let params = {
          headerId: this.model.id,
          type: 1,
          mpList: getMpListShort(Vue.ls.get('materialPropertyList')), //扩展属性
          linkType: 'basic',
        }
        let url = this.readOnly ? this.url.detailList : this.url.detailList
        this.requestSubTableData(url, params, this.materialTable)
      }
      //复制新增单据-初始化单号和日期
      if (this.action === 'copyAdd') {
        this.model.id = ''
        this.model.tenantId = ''
        this.copyAddInit(this.prefixNo)
      }
      
      this.initSystemConfig()
      this.initSupplier()
      this.initDepot()
    },
    //提交单据时整理成formData
    classifyIntoFormData(allValues) {
      let totalPrice = 0
      let billMain = Object.assign(this.model, allValues.formValue)
      let detailArr = allValues.tablesValue[0].values
      console.log(detailArr,'detailArr=======================')
      // billMain.type = '入库'
      // billMain.subType = '其它'
      billMain.defaultNumber = billMain.number
      for (let item of detailArr) {
        totalPrice += item.allPrice - 0
      }
      billMain.totalPrice = 0 - totalPrice
      if (this.fileList && this.fileList.length > 0) {
        billMain.fileName = this.fileList
      } else {
        billMain.fileName = ''
      }
      if (this.model.id) {
        billMain.id = this.model.id
        billMain.status = this.billStatus
        const linkInfoList = detailArr
        return {
          // info: JSON.stringify(billMain),
          id: billMain.id,
          code: billMain.code,
          date: billMain.date,
          acceptedBy: billMain.acceptedBy,
          transportationTools: billMain.transportationTools,
          refrigerationMethod: billMain.refrigerationMethod,
          regCode: billMain.regCode,
          regBy: billMain.regBy,
          unitMeasurement: billMain.unitMeasurement,
          startTime: billMain.startTime,
          startIceState: billMain.startIceState,
          saveTemperature: billMain.saveTemperature,
          ambientTemperature: billMain.ambientTemperature,
          reachTime: billMain.reachTime,
          reachTemperature: billMain.reachTemperature,
          reachAmbientTemperature: billMain.reachAmbientTemperature,
          reachIceState: billMain.reachIceState,
          inTransitTemperature: billMain.inTransitTemperature,
          freightCarrier: billMain.freightCarrier,
          freightComplaint: billMain.freightComplaint,
          consignee: billMain.consignee,
          consigneeComplaint: billMain.consigneeComplaint,
          remark: billMain.remark,
          linkInfoList: linkInfoList,
        }
      } else {
        billMain.status = this.billStatus
        const linkInfoList = detailArr.map(({ id, ...rest }) => rest)
        return {
          // info: JSON.stringify(billMain),
          id: billMain.id,
          code: billMain.code,
          date: billMain.date,
          acceptedBy: billMain.acceptedBy,
          transportationTools: billMain.transportationTools,
          refrigerationMethod: billMain.refrigerationMethod,
          regCode: billMain.regCode,
          regBy: billMain.regBy,
          unitMeasurement: billMain.unitMeasurement,
          startTime: billMain.startTime,
          startIceState: billMain.startIceState,
          saveTemperature: billMain.saveTemperature,
          ambientTemperature: billMain.ambientTemperature,
          reachTime: billMain.reachTime,
          reachTemperature: billMain.reachTemperature,
          reachAmbientTemperature: billMain.reachAmbientTemperature,
          reachIceState: billMain.reachIceState,
          inTransitTemperature: billMain.inTransitTemperature,
          freightCarrier: billMain.freightCarrier,
          freightComplaint: billMain.freightComplaint,
          consignee: billMain.consignee,
          consigneeComplaint: billMain.consigneeComplaint,
          remark: billMain.remark,
          linkInfoList: linkInfoList,
        }
      }
      
    },
    // 保存
    // handleOk(){
    //   // 获取表格数据
    //   debugger
    //   console.log(this.materialTable.dataSource,'materialTable.dataSource===========')
    // },
    onSearchLinkNumber() {
      this.$refs.waitBillList.show('入库', '采购,销售退货', '1,3')
      this.$refs.waitBillList.title = '选择采购入库或销售退货'
    },
    waitBillListOk(selectBillDetailRows, linkNumber, remark) {
      this.rowCanEdit = false
      this.materialTable.columns[1].type = FormTypes.normal
      this.changeFormTypes(this.materialTable.columns, 'preNumber', 1)
      this.changeFormTypes(this.materialTable.columns, 'finishNumber', 1)
      if (selectBillDetailRows && selectBillDetailRows.length > 0) {
        let listEx = []
        for (let j = 0; j < selectBillDetailRows.length; j++) {
          let info = selectBillDetailRows[j]
          if (info.finishNumber > 0) {
            info.operNumber = info.preNumber - info.finishNumber
          }
          info.unitPrice = 0
          info.allPrice = 0
          info.linkId = info.id
          listEx.push(info)
          this.changeColumnShow(info)
        }
        this.materialTable.dataSource = listEx
        this.$nextTick(() => {
          this.form.setFieldsValue({
            linkNumber: linkNumber,
            remark: remark,
          })
        })
      }
    },
  },
}
</script>
<style scoped>
</style>